export default __webpack_public_path__ + "static/media/2.6de5e477.png";